import React, { useContext } from "react";
import { InfoBarContext } from "../../../../common/info";
import { cleanJoin } from "../../../../utils/stringUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";

function Previous({ disabled, label }) {
  const { dispatch } = useContext(RequestSubmissionContext);
  const infoBar = useContext(InfoBarContext);

  return (
    <button
      onClick={(e) => {
        dispatch({ type: "previous" });
        e.currentTarget.blur();
        if(infoBar.isOpen){
          infoBar.toggle();
        }
      }}
      className={cleanJoin(
        "button",
        "pdf-form-action-button",
        "no-focus-outline",
        "has-border-yellow-1",
        !disabled
          ? "has-background-warning-on-hover has-text-white-on-hover has-opacity-71-on-hover"
          : ""
      )}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export default Previous;
